import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { DictionaryFuelPriceIndexService } from 'src/app/shared';
import {
  CustomButtonDefinition,
  DataTableDataDefinition,
} from 'src/app/shared/fca-data-table';
import { DictionaryFuelPriceIndexRecord } from 'src/app/shared/types/dictionary-fuel-price-index-record';
import { DictionaryType } from 'src/components/shared/dictionaries-layout';
import { DictionariesFuelPriceIndexAddNewDialogComponent } from './dictionaries-fuel-price-index-add-new-dialog/dictionaries-fuel-price-index-add-new-dialog.component';
import { NoopScrollStrategy } from '@angular/cdk/overlay';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ConfirmationDialogComponent } from 'src/components/shared/confirmation-dialog/confirmation-dialog.component';

@Component({
  selector: 'dictionaries-fuel-price-index-tab',
  templateUrl: './dictionaries-fuel-price-index-tab.html',
  styleUrls: ['./dictionaries-fuel-price-index-tab.scss'],
})
export class DictionariesFuelPriceIndexTab implements OnInit {
  title = 'Dictionary';
  dictionaryType = DictionaryType.FuelPriceIndex;

  pageSize = 10;
  data: DictionaryFuelPriceIndexRecord[] | null = null;
  dataDefinition: DataTableDataDefinition<DictionaryFuelPriceIndexRecord> = [
    {
      name: '',
      columns: [
        {
          fieldName: 'symbol',
          caption: 'SYMBOL PLATTS',
          valueType: 'text',
        },
        {
          fieldName: 'name',
          caption: 'INDEX NAME PLATTS',
          valueType: 'text',
        },
        {
          fieldName: 'fcaUpdateTimestamp',
          caption: 'FCA LAST UPDATE',
          valueType: 'date',
          format: 'dd.MM.yyyy HH:mm'
        },
        {
          fieldName: 'plattsUpdateTimestamp',
          caption: 'PLATTS LAST UPDATE',
          valueType: 'date',
          format: 'dd.MM.yyyy HH:mm'
        }
      ],
    },
    {
      name: '',
      columns: [
        {
          fieldName: 'indexValueDaily',
          caption: 'DAILY',
          valueType: 'number'
        },
        {
          fieldName: 'assessDate',
          caption: 'ASSESS DATE',
          valueType: 'date',
          format: 'dd.MM.yyyy'
        },
      ]
    },
    {
      name: '',
      columns: [
        {
          fieldName: 'indexValueWeeklyMonday',
          caption: 'WEEKLY (MON)',
          valueType: 'number'
        },
        {
          fieldName: 'indexValueWeeklyTuesday',
          caption: 'WEEKLY (TUE)',
          valueType: 'number'
        },
        {
          fieldName: 'indexValueWeeklyBiweekly',
          caption: 'BIWEEKLY',
          valueType: 'number'
        },
        {
          fieldName: 'indexValueMonthly',
          caption: 'MONTHLY',
          valueType: 'number'
        }
      ]
    },
    {
      name: '',
      columns: [
        {
          fieldName: 'uom1',
          caption: 'UOM1',
          valueType: 'text'
        },
        {
          fieldName: 'uom2',
          caption: 'UOM2',
          valueType: 'text'
        }
      ]
    }
  ];

  customButtons: CustomButtonDefinition<DictionaryFuelPriceIndexRecord>[] = [
    {
      icon: 'delete_outline',
      hint: 'Delete row',
      onClick: this.onDelete.bind(this) as (x: any) => {},
    },
  ];

  constructor(
    private FuelPriceIndexService: DictionaryFuelPriceIndexService,
    private snackBar: MatSnackBar,
    public dialog: MatDialog
  ) {}

  ngOnInit() {
    this.loadData();
  }

  loadData() {
    this.FuelPriceIndexService.getAll().subscribe((FuelPriceIndex) => {
      this.data = FuelPriceIndex;
    });
  }

  addFuelPriceIndex() {
    let data: {
      name: string;
    } = {
      name: '',
    };

    const dialogRef = this.dialog.open(
      DictionariesFuelPriceIndexAddNewDialogComponent,
      {
        width: '440px',
        panelClass: 'custom-dialog-container',
        scrollStrategy: new NoopScrollStrategy(),
        data: data,
        disableClose: true,
      }
    );

    dialogRef.afterClosed().subscribe({
      next: (result: any) => {
        if (result !== true) {
          this.snackBar.open('Fuel price index added.', undefined, {
            duration: 2000,
          });
          this.loadData();
        }
      },
    });
  }

  onDelete(record: DictionaryFuelPriceIndexRecord) {
    const dialogRef = this.dialog.open(ConfirmationDialogComponent, {
      width: '350px',
      scrollStrategy: new NoopScrollStrategy(),
      data: {
        title: 'Confirmation',
        message: 'Are you sure you want to remove this item?',
        buttons: {
          cancel: 'No',
          confirm: 'Yes'
        }
      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result === 'Yes') {
        this.FuelPriceIndexService.delete(record.id).subscribe({
          next: () => {
            this.loadData();
          },
          error: (error) => {
            if (error?.error?.ErrorCode === 'ERROR_DELETE_FUEL_PRICE_INDEX') {
              const lines: string[] = error.error.Message.split('\n');
              const records = lines.slice(1).filter((line) => line.trim() !== '');
              const recordsList = records.join('\n');
              const formattedMessage =
                `This Fuel Price Index is currently used in Airport Contract List module for following records:\n\n${recordsList}`;
              this.dialog.open(ConfirmationDialogComponent, {
                width: '350px',
                scrollStrategy: new NoopScrollStrategy(),
                panelClass: 'preformatted-dialog',
                data: {
                  title: 'Attention',
                  message: formattedMessage,
                  buttons: {
                    confirm: 'OK'
                  }
                }
              });
            } else {
              this.snackBar.open('An error occurred while deleting the record.', 'Close', { duration: 5000 });
            }
          }
        });
      }
    });
  }
}
